// Shop order progress, as returned by the API (`progress`), see ShopOrder::progressLabel in the backend
export const ORDER_PROGRESS = {
  Placed: { color: "#64748b", filter: "placed" },
  Confirmed: { color: "#2563eb", filter: "confirmed" },
  "Out For Delivery": { color: "#0d9488", filter: "out" },
  Delivered: { color: "#16a34a", filter: "delivered" },
  Cancelled: { color: "#dc2626", filter: "cancelled" },
};

export const PAYMENT_METHOD_LABEL = {
  cod: "Pay on delivery",
  manual: "Bank transfer / manual",
};

export const progressColor = (progress) => ORDER_PROGRESS[progress]?.color || "#64748b";
